import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


const DropdownMenu = ({
    title,
    options,
    isActive,
    handleToggle,
    dropdown,
    subMenuOptions,
    subMenuActive,
    handleSubMenuToggle,
}) => {   const { t } = useTranslation();
    return (
        <div className="servicesContainer">
            <div className="serviceTextContainer" onClick={handleToggle}>
                <button
                    className={`secondary-header-button ${
                        isActive && "activeWindow"
                    }`}
                >
                    {title}
                </button>
                <img
                    className="imgHeaderservices"
                    src={`${
                        isActive
                            ? "/img/arrowUpHeader.svg"
                            : "/img/arrowDownHeader.svg"
                    }`}
                    alt=""
                />
            </div>

            <div
                className={`ServicesNavbar ${isActive && "active"} ${dropdown}`}
            >
                <div>
                    {dropdown === "Services" ? (
                        <>
                            <p className="serviceElement headerTitle">
                                {t("HEADER_SERVICES")}
                            </p>
                            {subMenuOptions && (
                                <p
                                    className={`techServicesContainer ${
                                        subMenuActive ? "active" : ""
                                    }`}
                                >
                                    <Link
                                        to={subMenuOptions.link}
                                        onClick={handleSubMenuToggle}
                                        className="serviceElement"
                                    >
                                        {subMenuOptions.title}
                                    </Link>
                                    <img
                                        className="imgHeaderservices"
                                        src={`${
                                            subMenuActive
                                                ? "/img/arrowRightHeader.svg"
                                                : "/img/arrowDownHeader.svg"
                                        }`}
                                        alt=""
                                        onClick={handleSubMenuToggle}
                                    />
                                    <div
                                        className={`techServicesNavBarContainer ${
                                            subMenuActive && "active"
                                        } mobile`}
                                    >
                                        <div className="headerDropdownLine"></div>
                                        <div
                                            className={`TechServicesNavbar ${
                                                subMenuActive && "active"
                                            }`}
                                        >
                                            {subMenuOptions.items.map(
                                                (item, index) => (
                                                    <ul key={index}>
                                                        <li>
                                                            <p>
                                                                <Link
                                                                    to={
                                                                        item.link
                                                                    }
                                                                >
                                                                    {item.name}
                                                                    {item.name2}
                                                                </Link>
                                                            </p>
                                                        </li>
                                                    </ul>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </p>
                            )}
                            {options.map((option, index) => (
                                <p key={index} className="serviceElement">
                                    {option.external ? (
                                        <a
                                            href={option.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="serviceElement"
                                        >
                                            {option.name}
                                        </a>
                                    ) : (
                                        <Link
                                            to={option.link}
                                            className="serviceElement"
                                        >
                                            {option.name}
                                        </Link>
                                    )}
                                </p>
                            ))}
                        </>
                    ) : (
                        options.map((option, index) => (
                            <p key={index} className="serviceElement">
                                {option.external ? (
                                    <a
                                        href={option.link}
                                        rel="noopener noreferrer"
                                        className="serviceElement"
                                    >
                                        {option.name}
                                    </a>
                                ) : (
                                    <Link
                                        to={option.link}
                                        className="serviceElement"
                                    >
                                        {option.name}
                                    </Link>
                                )}
                            </p>
                        ))
                    )}
                </div>

                {subMenuOptions && (
                    <div
                        className={`techServicesNavBarContainer ${
                            subMenuActive && "active"
                        } desk`}
                    >
                        <div className="headerDropdownLine"></div>
                        <div
                            className={`TechServicesNavbar ${
                                subMenuActive && "active"
                            }`}
                        >
                            {subMenuOptions.items.map((item, index) => (
                                <ul key={index}>
                                    <li>
                                        <p>
                                            <Link to={item.link}>
                                                {item.name}
                                                {item.name2}
                                            </Link>
                                        </p>
                                    </li>
                                </ul>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DropdownMenu;
